import useSWR, { SWRConfiguration, SWRResponse, Key } from 'swr'
import { useAppStore } from '@forwardflow/store'

/**
 * Custom SWR hook that automatically includes currentOrganization in the cache key
 * This ensures data is properly segregated by organization
 */
export function useOrgSWR<Data = any, Error = any>(
   key: Key,
   fetcher: (() => Data | Promise<Data>) | null,
   config?: SWRConfiguration<Data, Error>
): SWRResponse<Data, Error> {
   const { currentOrganization } = useAppStore()

   // Automatically prepend currentOrganization to the key
   const orgKey = key ? [key, currentOrganization].flat() : null

   return useSWR<Data, Error>(orgKey, fetcher, config)
}

